import { load } from '@/router/routes/index';

export default [
    {
        path: 'sales-reports',
        name: 'sales-report.index',
        component: load('sales-report/SalesReportIndex'),
        meta: { auth: true },
    },
    {
        path: 'sales-reports/create',
        name: 'sales-report.create',
        component: load('sales-report/SalesReportCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'sales-reports/:salesReportId',
        component: load('sales-report/SalesReportDetail'),
        meta: { auth: true },
        children: [
            {
                path: '',
                component: load('sales-report/SalesReportShow'),
                meta: { auth: true },
                children: [
                    {
                        path: '',
                        name: 'sales-report.show',
                        component: load('sales-report/SalesReportShowOverview'),
                        meta: { auth: true },
                    },
                ],
            },
            {
                path: 'edit',
                name: 'sales-report.edit',
                component: load('sales-report/SalesReportEdit'),
                meta: { auth: true, forceCollapsedMenu: true },
            },
        ],
    },

    {
        path: 'materials',
        name: 'materials.index',
        component: load('sales-report/MaterialIndex'),
        meta: { auth: true },
    },
    {
        path: 'materials/create',
        name: 'materials.create',
        component: load('sales-report/MaterialCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'sales-reports/:materialId',
        component: load('sales-report/MaterialDetail'),
        meta: { auth: true },
        children: [
            {
                path: '',
                component: load('sales-report/MaterialShow'),
                meta: { auth: true },
                children: [
                    {
                        path: '',
                        name: 'material.show',
                        component: load('sales-report/MaterialShowOverview'),
                        meta: { auth: true },
                    },
                    {
                        path: 'sales-reports',
                        name: 'material.show.sales-reports',
                        component: load('sales-report/MaterialShowSalesReport'),
                        meta: { auth: true },
                    },
                ],
            },
            {
                path: 'edit',
                name: 'material.edit',
                component: load('sales-report/MaterialEdit'),
                meta: { auth: true, forceCollapsedMenu: true },
            },
        ],
    },

    {
        path: 'interests',
        name: 'interests.index',
        component: load('sales-report/InterestIndex'),
        meta: { auth: true },
    },
    {
        path: 'interests/create',
        name: 'interests.create',
        component: load('sales-report/InterestCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'sales-reports/:interestId',
        component: load('sales-report/InterestDetail'),
        meta: { auth: true },
        children: [
            {
                path: '',
                component: load('sales-report/InterestShow'),
                meta: { auth: true },
                children: [
                    {
                        path: '',
                        name: 'interest.show',
                        component: load('sales-report/InterestShowOverview'),
                        meta: { auth: true },
                    },
                    {
                        path: 'sales-reports',
                        name: 'interest.show.sales-reports',
                        component: load('sales-report/InterestShowSalesReport'),
                        meta: { auth: true },
                    },
                ],
            },
            {
                path: 'edit',
                name: 'interest.edit',
                component: load('sales-report/InterestEdit'),
                meta: { auth: true, forceCollapsedMenu: true },
            },
        ],
    },

];
